//store
import store from "../../Redux/store";
//base communication
import BaseCommunication from "../../Communication/BaseCommunication";
//constants
import {
  ALERT_ACTION,
  CREATE_ALERT_ACTION,
  DELETE_ALERT_ACTION,
} from "./Constants";
import {
  API_URL,
  API_BASE_URL,
  HttpMethod,
  OperationStatus,
} from "../../Communication/Constants";

export default class AlertAction extends BaseCommunication {
  getAlerts(requestData, callback) {
    this.callAPI(
      ALERT_ACTION,
      API_BASE_URL + API_URL.ALERTS + "/" + requestData.userid,
      HttpMethod.GET,
      {},
      (apiResponse) => {
        if (apiResponse.status === OperationStatus.SUCCESS) {
          if (apiResponse.data !== null) {
            store.dispatch({
              type: ALERT_ACTION,
              response: apiResponse.data.data,
            });
          }
        }
        callback(apiResponse);
      }
    );
  }
  createAlert(requestData, callback) {
    this.callAPI(
      CREATE_ALERT_ACTION,
      API_BASE_URL + API_URL.ALERTS,
      HttpMethod.POST,
      requestData,
      (apiResponse) => {
        this.res = apiResponse;
        if (apiResponse.status === OperationStatus.SUCCESS) {
          store.dispatch({
            type: CREATE_ALERT_ACTION,
            data: apiResponse.data,
            error: apiResponse.error,
          });
        }
        callback(apiResponse);
      }
    );
  }

  deleteAlert(requestData, callback) {
    this.callAPI(
      DELETE_ALERT_ACTION,
      API_BASE_URL + API_URL.ALERTS + "/" + requestData + API_URL.DISABLE,
      HttpMethod.PUT,
      {},
      (apiResponse) => {
        this.res = apiResponse;
        if (apiResponse.status === OperationStatus.SUCCESS) {
          store.dispatch({
            type: CREATE_ALERT_ACTION,
            data: apiResponse.data,
            error: apiResponse.error,
          });
        }
        callback(apiResponse);
      }
    );
  }
}
